export default {
  /**
   *  @type {string} 検索画面
   */
  search: '/admin/category/',
  /**
   * 参照画面
   * @param {string} id CategoryId
   */
  refer: (id) => {
    return `/admin/category/refer/${id}`;
  },
  /**
   * @type {string} 新規作成画面
   */
  newEdit: '/admin/category/edit/',
  /**
   * 編集画面
   * @param {string} id CategoryId
   */
  edit: (id) => {
    return `/admin/category/edit/${id}`;
  },
};
